module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.itemConf), function(conf, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mb-2"
    }, [_c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_vm._v(_vm._s(_vm.forUser && _vm.isLeaf(conf) && conf.__Value__.__desc__ ? conf.__Value__.__desc__ : conf.__Key__) + " "), (_vm.isArray(conf)) ? _c('i', {
      staticClass: "i-type"
    }, [_vm._v("[" + _vm._s(conf.__Value__.length) + "]")]) : _vm._e()]), _vm._v(" "), (_vm.isArray(conf)) ? _c('b-col', _vm._l((conf.__Value__), function(c, index) {
      return _c('span', {
        key: index
      }, [(_vm.isLeaf(c)) ? _c('conf-field', {
        attrs: {
          "conf": c.__Value__,
          "useDefault": _vm.useDefault,
          "userPerm": _vm.userPerm,
          "strict": _vm.strict,
          "notData": _vm.notData
        }
      }) : _c('confnode', {
        attrs: {
          "items": c,
          "useDefault": _vm.useDefault,
          "forUser": _vm.forUser,
          "userPerm": _vm.userPerm,
          "strict": _vm.strict,
          "notData": _vm.notData
        },
        on: {
          "update:items": function($event) {
            c = $event
          }
        }
      })], 1)
    }), 0) : (_vm.isLeaf(conf)) ? _c('b-col', [_c('conf-field', {
      attrs: {
        "conf": conf.__Value__,
        "useDefault": _vm.useDefault,
        "userPerm": _vm.userPerm,
        "strict": _vm.strict,
        "notData": _vm.notData
      }
    })], 1) : _c('b-col', [_c('confnode', {
      attrs: {
        "items": conf,
        "useDefault": _vm.useDefault,
        "forUser": _vm.forUser,
        "userPerm": _vm.userPerm,
        "strict": _vm.strict,
        "notData": _vm.notData
      },
      on: {
        "update:items": function($event) {
          conf = $event
        }
      }
    })], 1), _vm._v(" "), (_vm.addable) ? _c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(conf.__Key__)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus"
    })])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.addable) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  })])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3f7f0260!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confnode.vue
// module id = XqgM
// module chunks = 4